export const updateLanguage = (payload) => {
    return {
        type: 'language/update',
        payload
    }
}